import { render, staticRenderFns } from "./Editar.vue?vue&type=template&id=87e3cb54&scoped=true"
import script from "./Editar.vue?vue&type=script&lang=js"
export * from "./Editar.vue?vue&type=script&lang=js"
import style0 from "./Editar.vue?vue&type=style&index=0&id=87e3cb54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e3cb54",
  null
  
)

export default component.exports